// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @helpers
const { toCamelCase } = require('utilities/stringHelper');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { SPAIN_COUNTRY_CODE } = require('constants/index');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { PROC_OPEN_YOUNG_CONTACT_DATA } = require('utilities/tagging');

class OpenYoungContactDataError extends React.Component {
    buildGoBackButton() {
        return {
            label: (
                <FormattedText
                    format="uppercase"
                    value="openYoungContactData-openYoungContactData_errorBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };
    }
    buildWizardError() {
        const goBackButton = this.buildGoBackButton();
        return (
            <WizardError
                errorMessage={formatText('openYoungContactData-openYoungContactData_errorTitle')}
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_CONTACT_DATA}
            >
                <FormattedText
                    value="openYoungContactData-openYoungContactData_errorText"
                />
            </WizardError>
        );
    }

    buildWizardErrorWithAddressSuccess() {
        const { immHireContactData, immOpenYoungProfileDetails } = this.props;
        const goBackButton = this.buildGoBackButton();
        const fullNameChild = toCamelCase(immOpenYoungProfileDetails.get('fullName'));
        const errorMessage = (
            <FormattedText
                value="openYoungContactData-openYoungContactData_errorTitleAddressSuccessWithName"
                injectedStrings={[fullNameChild]}
            />
        );

        return (
            <WizardError
                errorMessage={errorMessage}
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_CONTACT_DATA}
            >
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newAddress')}
                        onlyChildren
                    >
                        {PersonalDataHelper.getHireFormattedAddress(immHireContactData)}
                    </OKInformativeListItem>
                </OKInformativeList>
                <p>
                    <FormattedText value="openYoungContactData-openYoungContactData_errorTextMobile" />
                </p>
            </WizardError>
        );
    }

    buildWizardErrorWithMobileSuccess() {
        const { immHireContactData, immOpenYoungProfileDetails } = this.props;
        const goBackButton = this.buildGoBackButton();
        const fullNameChild = toCamelCase(immOpenYoungProfileDetails.get('fullName'));
        const errorMessage = (
            <FormattedText
                value="openYoungContactData-openYoungContactData_errorTitleMobileSuccessWithName"
                injectedStrings={[fullNameChild]}
            />
        );

        return (
            <WizardError
                errorMessage={errorMessage}
                icon="error"
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_CONTACT_DATA}
            >
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newMobile')}
                        onlyChildren
                    >
                        {PersonalDataHelper.formattedPhone(SPAIN_COUNTRY_CODE, immHireContactData.getIn(['mobile', 'value']))}
                    </OKInformativeListItem>
                </OKInformativeList>
                <p>
                    <FormattedText value="openYoungContactData-openYoungContactData_errorTextAddress" />
                </p>
            </WizardError>
        );
    }

    render() {
        const {immOpenYoungProfileDetails} = this.props;
        let content;

        if (immOpenYoungProfileDetails.get('isAddressError') && !immOpenYoungProfileDetails.get('isMobileError') ) {
            content = this.buildWizardErrorWithMobileSuccess();
        } else if (immOpenYoungProfileDetails.get('isMobileError') && !immOpenYoungProfileDetails.get('isAddressError')) {
            content = this.buildWizardErrorWithAddressSuccess();
        } else {
            content = this.buildWizardError();
        }

        return content;
    }
}

OpenYoungContactDataError.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
};

module.exports = OpenYoungContactDataError;
